"use client";

import {
  Box,
  Paper,
  Typography,
  Avatar,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Diversity3Rounded,
  AccessTimeRounded,
  LocationOnRounded,
  FiberManualRecordRounded,
  LocalFireDepartmentRounded,
} from "@mui/icons-material";

const colors = {
  bg: "#0b0b0f",
  card: "#0f1014",
  tile: "#141519",
  border: "#1f1f23",
  text: "#e5e7eb",
  subtext: "#9aa0a6",
  purple: "#a78bfa",
  purpleDim: "#7c6ee6",
  green: "#10b981",
  yellow: "#fbbf24",
};

function InfoTile({ icon: Icon, label, value }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: "5px 10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          width: "100%",
          // bgcolor: "#f3f4ffff",
          borderRadius: 5,
          p: "30px 20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap:0.8
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              bgcolor: "transparent",
              border: `1.5px solid ${"#6366F1"}`,
              display: "grid",
              placeItems: "center",
            }}
          >
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                bgcolor: "#6366F1",
              }}
            />
          </Box>
          <Typography
            variant="caption"
            sx={{ fontWeight: 500,  color: "#71717A" }}
          >
            {label}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
          {Icon ? <Icon sx={{ fontSize: 18, color: "#6366F1" }} /> : null}
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, fontSize: "0.75rem" }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default function AgentHeaderCard({avatar,agentName="Default User"}) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 5,
        border: `0.5px solid #D2D2D2`,
        // p: 0.5,
        // boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "1fr 1fr 1fr 1fr",
          },
          //   gap: { xs: 1.5, sm: 2 },
          alignItems: "stretch",
        }}
      >
        {/* Profile block */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            p: { xs: 1.75, sm: 2 },
            display: "flex",
            // alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            backgroundColor: "transparent",
          }}
        >
          <Box sx={{}}>
            <Avatar
              src={avatar || "https://img.freepik.com/premium-photo/3d-avatar-cartoon-character_113255-103130.jpg"}
              alt="Agent avatar"
              sx={{
                width: { xs: 48, sm: 66 },
                height: { xs: 48, sm: 66 },
                border: `1px solid #D2D2D2`,
              }}
            />
            {/* Level badge */}
            {/* <Box
              sx={{
                position: "absolute",
                bottom: -6,
                left: 0,
                bgcolor: colors.yellow,
                color: "#1f2937",
                px: 0.75,
                py: 0.25,
                borderRadius: 10,
                fontSize: 11,
                fontWeight: 800,
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
              }}
            >
              L12
            </Box> */}
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 ,display:'flex',flexDirection:"column",justifyContent:"center",alignItems:'flex-start'}}>
            <Typography
              variant={isSm ? "subtitle1" : "h6"}
              sx={{
                color: "#6366F1",
                fontWeight: 700,
                lineHeight: 1.1,
                mb: 0.25,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {agentName}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, mb: 0.25, color: "#71717A" }}
            >
              Customer Support Executive
            </Typography>
            {/* <Typography variant="caption" sx={{ color: "#95959bff" }}>
              3 Years 4 Months in Contact Center
            </Typography> */}

            {/* <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1.25 }}>
              <Chip
                size="small"
                icon={
                  <FiberManualRecordRounded
                    sx={{ color: colors.green, fontSize: 12 }}
                  />
                }
                label="Online"
                sx={{
                  bgcolor: "rgba(16,185,129,0.12)",
                  //   color: colors.text,
                  border: `1px solid rgba(16,185,129,0.35)`,
                  ".MuiChip-icon": { ml: 0.5 },
                  fontWeight: 600,
                  height: 26,
                }}
              />

              <Chip
                size="small"
                icon={
                  <LocalFireDepartmentRounded
                    sx={{ color: "#ff7e33", fontSize: 16 }}
                  />
                }
                label="12 day streak"
                sx={{
                  bgcolor: "rgba(255,126,51,0.12)",
                  //   color: colors.text,
                  border: `1px solid rgba(255,126,51,0.35)`,
                  ".MuiChip-icon": { ml: 0.25 },
                  fontWeight: 600,
                  height: 26,
                }}
              />
            </Box> */}
          </Box>
        </Paper>

        {/* Tiles */}
        <InfoTile
          icon={Diversity3Rounded}
          label="Team"
          value="CS Operations"
        />
        <InfoTile
          icon={AccessTimeRounded}
          label="Shift"
          value="9:00 AM - 6:00 PM"
        />
        <InfoTile
          icon={LocationOnRounded}
          label="Location"
          value="Bhopal, India"
        />
      </Box>
    </Paper>
  );
}
